import axios from "axios";
// import Cookies from "js-cookie";

const GetFarmer = async (payload) => {
  const token = JSON.parse(localStorage.getItem("authentication"));
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/api/farmer/GetFarmer`,
      payload,
      config
    );

    if (data?.dateOfBirth === "") {
      data.dateOfBirth = null;
    }
    if (data?.idCardExpiryDate === "") {
      data.idCardExpiryDate = null;
    }

    return data;
  } catch (error) {
    if (error.response) {
      return { status: error.response.status, payload: null };
    } else if (error.request) {
      return { status: 500, payload: null };
    } else {
      return { status: 500, payload: null };
    }
  }
};

export default GetFarmer;
